import { getFromStorage } from '../utils';
import { evvToken } from '../constants';

import fetchRequest from './fetchRequest';

const craftRequestHeadersForGet = headers => {
  const headerWithoutContentType = { ...headers };
  delete headerWithoutContentType['Content-Type'];

  return headerWithoutContentType;
};

const createRequestObjectWith = async (httpMethod, headers) => {
  const defaultHeaders = {
    'Content-Type': 'application/json; charset=utf-8',
    Authorization: `Bearer ${getFromStorage(evvToken)}`,
    ...headers,
  };

  const requestHeaders =
    httpMethod === 'GET' ? craftRequestHeadersForGet(defaultHeaders) : defaultHeaders;

  return {
    method: httpMethod,
    credentials: 'include',
    headers: { ...requestHeaders },
  };
};

const appendBodyToRequest = (requestObject, requestBody) => ({
  ...requestObject,
  body: JSON.stringify(requestBody),
});

const callFetch = async (url, method, body, headers) => {
  const requestObj = await createRequestObjectWith(method, headers);

  return body
    ? fetchRequest(url, appendBodyToRequest(requestObj, body))
    : fetchRequest(url, requestObj);
};

const http = {
  get: async url => callFetch(url, 'GET'),
  post: async (url, body = {}, headers = {}) => callFetch(url, 'POST', body, headers),
  put: async (url, body = {}) => callFetch(url, 'PUT', body),
  patch: async (url, body = {}) => callFetch(url, 'PATCH', body),
  delete: async url => callFetch(url, 'DELETE'),
};

export default http;
